import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import { Col, Row, Divider, Spin } from "antd";
import "./VideoLecturePreview.scss";

const VideoLecturePreview = ({
  match,
  loading,
  location
}) => {
  const [selectedVideo, setSelectedVideo] = useState();
  const { videoLectureDetails } = location.state

  // Update the selected video when the videoLectureDetails dependency changes
  useEffect(() => {
    videoLectureDetails?.links &&
      setSelectedVideo(videoLectureDetails?.links[0]);
  }, [videoLectureDetails]);

  return (
    <div className="video-preview-container">
      <div className="preview-header">
        <h6>Video Lecture</h6>
      </div>
      <div className="video-preview-wrap">
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={16}>
            <Col span={10}>
              <div className="left-section">
                <span className="label">Video Topic</span>
                <p className="topic">{videoLectureDetails?.topic}</p>
                <Divider />
                <div className="videos-title-wrap">
                  {videoLectureDetails?.links?.map((item) => {
                    return (
                      <p
                        className={
                          selectedVideo?.title === item?.title
                            ? "selected-video-title"
                            : "video-title"
                        }
                        onClick={() => setSelectedVideo(item)}
                      >
                        {item?.title}
                      </p>
                    );
                  })}
                </div>
              </div>
            </Col>
            <Col span={12} offset={2} className="content-wrap">
              <span className="label">Video Sumary</span>
              <p className="summary">{selectedVideo?.summary}</p>
              <ReactPlayer
                url={selectedVideo?.link}
                controls
                height={350}
                width={"100%"}
              />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.VideoLecture.loading,
    videoLectureDetails: state.VideoLecture.videoLectureDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoLecturePreview);
